<template>
    <div class="human-index">
        <headerw ref="headerw"></headerw>
        <div class="human-content">
            <leftnav @navchange="navchange" @temload="temload"></leftnav>
            <component :is="getComp(tempactive)" @updatainfo="updatainfo"></component>
        </div>
    </div>
</template>

<script>
import headerw from '@/components/headerW.vue'
import leftnav from '@/components/humannav.vue'
const requireTemp = require.context('./components', false, /\.vue$/)

export default {
    components: {
        headerw,
        leftnav
    },
    data() {
        return {
            templist: [],
            tempactive: 'human'
        }
    },
    methods: {
        loadTemp() {
            const componentemp = requireTemp.keys().map(key => requireTemp(key))
            const loadhead = componentemp.map(component => component.default)
            this.templist = loadhead
        },
        getComp(name) {
            let comp = this.templist.find(item => item.name == name)
            return comp
        },
        navchange(name) {
            this.tempactive = name
        },
        temload(name) {
            this.tempactive = name
        },
        updatainfo() {
			let dom1 = this.$refs.headerw
			dom1.updateInfo()
        }
    },
    mounted() {
        this.loadTemp()
    }
}
</script>

<style scoped lang="scss">
.human-index {
    background: #F2F4F7;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding-bottom: 36px;
    &::-webkit-scrollbar {
        width: 0;
    }
    .human-content {
        margin: 28px auto;
        display: flex;
        height: 910px;
        column-gap: 18px;
        justify-content: center;
    }
    .human-left {
        width: 276px;
        background: #fff;
    }
    .human-right {
        width: 1378px;
        background: #fff;
    }
}
</style>